export default {
  methods: {
    eggIconClass (info) {
      const types = ['fu', 'yoo', 'dao', 'yoo_dao', '', 'yoo']
      return types[info.egg_type] || ''
    },

    isCash (info) {
      return info.property_name.indexOf('现金') >= 0
    },

    isCashDouble (info) {
      return info.property_double && info.property_name.indexOf('现金') >= 0
    },

    goodName (info) {
      if (info.property_double) {
        return info.property_name.replace(/(\D*)([\d|.]+)(.*)(现金)/g, ($0, $1, $2, $3, $4) => {
          return `${$1}${$2}${$3}<del class="before">${$2 / 2}${$3}</del>${$4}`
        })
      } else {
        return info.property_name
      }
    },
  }
}